import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch } from 'src/app/store/hooks';
import { DropdownMenuBasic } from 'src/common/DropdownMenu/DropdownMenuBasic';
import { DropdownMenuItem } from 'src/common/DropdownMenu/DropdownMenuItem';
import { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { tripSlice } from 'src/features/trip/trip.slice';

import { CANCEL_REASONS_OPTIONS } from '../CancelTripModal/cancellationReasons';

export default function GlobalReasonDropdownMenu({
  tripsToCancel,
}: {
  tripsToCancel: TripRead[];
}) {
  const dispatch = useAppDispatch();

  const tripsHaveIntermediary = tripsToCancel.some(
    (trip) => trip.intermediary_id
  );

  // if there is a broker trip, we can't set a global reason
  if (tripsHaveIntermediary) {
    return null;
  }

  return (
    <div>
      <DropdownMenuBasic
        trigger={
          <div>
            <Button
              dataTestId="global-cancel-reason-dropdown-trigger"
              variant="secondary"
              onClick={(e) => e.preventDefault()}
            >
              Select Global Cancel Reason
            </Button>
          </div>
        }
      >
        <div className="z-50">
          <>
            {CANCEL_REASONS_OPTIONS.map((option) => (
              <DropdownMenuItem
                onClick={() => {
                  const tripsWithGlobalReason = tripsToCancel.reduce(
                    (acc, trip) => {
                      acc[trip.id] = option.value;
                      return acc;
                    },
                    {} as Record<string, string>
                  );
                  dispatch(
                    tripSlice.actions.setBulkCancelReasons(
                      tripsWithGlobalReason
                    )
                  );
                }}
                key={option.value}
              >
                {option.label}
              </DropdownMenuItem>
            ))}
          </>
        </div>
      </DropdownMenuBasic>
    </div>
  );
}
